import apolloClient from '../../apolloClient';
import uploadQueries from '../queries/upload';

const getUploadUrl = async (variables) =>
  apolloClient.query({
    query: uploadQueries.GET_UPLOAD_URL,
    variables,
    fetchPolicy: 'no-cache',
  });

export default {
  getUploadUrl,
};
